<template>
  <f-form-group
    v-if="field_visible"
    :field-errors="fieldErrors"
    :required="field.required"
    :label="field_label"
    :hide-label="hideLabel"
    :horizontal="horizontal"
    v-b-tooltip="tooltip"
  >
    <o-file-upload
      :disabled="is_disabled"
      :file="field_value"
      :title="field.name"
      @change="on_input"
      v-bind="field.params"
    ></o-file-upload>
  </f-form-group>
</template>

<script>
import FormWidgetMixin from "../FormWidgetMixin.js";
import OFileUpload from "../../../vue-ocom/filesystem/OFileUpload.vue";
import FFormGroup from "../FFormGroup.vue";

export default {
  name: "FileuploadWidget",
  components: { FFormGroup, OFileUpload },
  mixins: [FormWidgetMixin],
};
</script>
